'use client';

import { Toaster } from 'sonner';

export interface ToastProviderProps {
  children: React.ReactNode;
}

export function ToastProvider({ children }: ToastProviderProps) {
  return (
    <>
      {children}
      <Toaster
        position="top-right"
        expand={true}
        richColors={true}
        closeButton={true}
        toastOptions={{
          duration: 4000,
          style: {
            background: '#ffffff',
            color: '#1f2937',
            border: '1px solid #e5e7eb',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
          },
          classNames: {
            toast: 'opacity-100',
            error: 'bg-red-50 text-red-900 border-red-200',
            success: 'bg-green-50 text-green-900 border-green-200',
            warning: 'bg-yellow-50 text-yellow-900 border-yellow-200',
            info: 'bg-blue-50 text-blue-900 border-blue-200',
          },
        }}
      />
    </>
  );
}

export default ToastProvider;
